import {
  type AdminDraft,
  emptyDraft,
  type SaveStatus,
  type ValidationErrors,
} from '../../_shared/domain/administrator-draft.model';
import type { AddAdministratorError } from '../domain/add-administrator-error';

/**
 * Redux state for the Add-administrator form. Small by design: the editable
 * draft, the save lifecycle, the last business error, and per-field validation
 * messages. Every field is serialisable so the slice can be persisted / replayed.
 */
export interface AddAdministratorState {
  draft: AdminDraft;
  saveStatus: SaveStatus;
  validationErrors: ValidationErrors;
  error: AddAdministratorError | null;
}

export const initialState: AddAdministratorState = {
  draft: emptyDraft,
  saveStatus: 'idle',
  validationErrors: {},
  error: null,
};
